export default __webpack_public_path__ + "static/media/IMG_Available_Card.ff9b7f96.png";